import React from 'react'
import { HashRouter as Router, Routes, Route } from 'react-router-dom'
import Home from 'pages/Home'
import About from 'pages/About'
import Services from 'pages/Services'
import Lawyers from 'pages/Lawyers/Lawyers'
import Contact from 'pages/Contact/Contact'
import AboutLawyer from 'pages/AboutLawyer'
import ServiceDetails from 'pages/ServiceDetails'

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/quem-somos' element={<About />} />
        <Route path='/servicos' element={<Services />} />
        <Route path='/advogados' element={<Lawyers />} />
        <Route path='/contatos' element={<Contact />} />
        <Route path='/lawyer/:lawyerName/:oab' element={<AboutLawyer />} />
        <Route path='/servico/:serviceName' element={<ServiceDetails />} />
      </Routes>
    </Router>
  )
}

export default App

// import React from 'react'
// import { RouterProvider, createBrowserRouter } from 'react-router-dom'
// import Home from 'pages/Home'
// import About from 'pages/About'
// import Services from 'pages/Services'
// import Lawyers from 'pages/Lawyers/Lawyers'
// import Contact from 'pages/Contact/Contact'

// import AboutLawyer from 'pages/AboutLawyer'
// import ServiceDetails from 'pages/ServiceDetails'

// const routes = createBrowserRouter([
//   { path: '/', element: <Home /> },
//   { path: '/quem-somos', element: <About /> },
//   { path: '/servicos', element: <Services /> },
//   { path: '/advogados', element: <Lawyers /> },
//   { path: '/contatos', element: <Contact /> },
//   { path: '/lawyer/:lawyerName/:oab', element: <AboutLawyer /> },
//   { path: '/servico/:serviceName', element: <ServiceDetails /> },
// ])

// const App = () => {
//   return <RouterProvider router={routes} />
// }

// export default App